// 画面ごとのヘルプの中身。手引き（BuilderGuideBook）と同じ作りで、
// その画面のキャプチャの「どこを見るか」を丸で囲んだり拡大したりして見せる。
// 文章だけのヘルプは読まれないので使わない。
//
// focus は実画面を getBoundingClientRect で実測した値（ビューポート 1280x800 に対する比率）。
// キャプチャの撮り直しは scripts/capture-guide.mjs。

import {
  GuideRect,
  GuideBookPage,
  GuideFocusMode,
  GuideBookChapter,
} from "features/builder/elements/BuilderGuideBook";

const KEY = "MSG_BUILDER_HELP";

const page = (
  capture: string,
  key: string,
  mode: GuideFocusMode,
  focus?: GuideRect,
): GuideBookPage => ({
  key: `${capture}_${key}`,
  capture,
  mode,
  focus,
  titleKey: `${KEY}_${key.toUpperCase()}_TITLE`,
  descKey: `${KEY}_${key.toUpperCase()}_DESC`,
});

const zoom = (capture: string, key: string, focus: GuideRect) =>
  page(capture, key, GuideFocusMode.ZOOM, focus);

const chapter = (key: string, icon: string, pages: GuideBookPage[]): GuideBookChapter[] => [
  { key, icon, labelKey: `${KEY}_${key.toUpperCase()}_TITLE`, pages },
];

/** くわしく（ピースじょうほう） */
export const HELP_DETAIL = chapter("detail", "info", [
  zoom("info", "detail_tabs", { x: 0.4, y: 0.293, w: 0.49, h: 0.085 }),
  zoom("info", "detail_name", { x: 0.405, y: 0.385, w: 0.48, h: 0.12 }),
  zoom("info", "detail_cover", { x: 0.1, y: 0.6, w: 0.31, h: 0.2 }),
]);

/** AIで マップを つくる */
export const HELP_AI = chapter("ai", "smart_toy", [
  zoom("ai", "ai_level", { x: 0.125, y: 0.275, w: 0.35, h: 0.19 }),
  zoom("ai", "ai_floor", { x: 0.125, y: 0.46, w: 0.35, h: 0.18 }),
  zoom("ai", "ai_create", { x: 0.115, y: 0.69, w: 0.36, h: 0.13 }),
]);

/** ブロックを えらぼう */
export const HELP_ASSET = chapter("asset", "category", [
  zoom("assets", "asset_all", { x: 0.156, y: 0.159, w: 0.688, h: 0.682 }),
  zoom("assets", "asset_kind", { x: 0.175, y: 0.265, w: 0.32, h: 0.1 }),
  zoom("assets", "asset_pick", { x: 0.175, y: 0.33, w: 0.52, h: 0.28 }),
]);

/** へんしゅう りれき */
export const HELP_HISTORY = chapter("history", "history", [
  zoom("history", "history_all", { x: 0.219, y: 0.159, w: 0.563, h: 0.682 }),
  zoom("history", "history_item", { x: 0.27, y: 0.255, w: 0.5, h: 0.14 }),
  zoom("history", "history_undo", { x: 0.63, y: 0.395, w: 0.15, h: 0.1 }),
]);

/** かんせいの じゅんび（左パネル） */
export const HELP_PUBLISH = chapter("publish", "rocket_launch", [
  zoom("main", "publish_steps", { x: 0.004, y: 0.156, w: 0.378, h: 0.625 }),
  // キャラクターとゴールは じめんの上にしか置けない。詰まりやすいので先に伝える
  zoom("main", "publish_ground", { x: 0.236, y: 0.882, w: 0.432, h: 0.112 }),
  zoom("main", "publish_check", { x: 0.018, y: 0.26, w: 0.354, h: 0.088 }),
  zoom("main", "publish_go", { x: 0.012, y: 0.704, w: 0.362, h: 0.073 }),
]);
